import { faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Form,
  Row,
  Table,
} from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select, { SingleValue } from "react-select";
import { toast } from "react-toastify";
import { Label } from "reactstrap";
import BreadCrumbs from "../../../../components/BreadCrumbs";
import ButtonComponent from "../../../../components/ButtonComponent";
import ControlledRowTextField from "../../../../components/ControlledRowTextField";
import ControlledSelect from "../../../../components/ControlledSelect";
import IMGUploadComponent from "../../../../components/IMGUploadComponent";
import LoadingMessage from "../../../../components/LoadingMessage";
import { uploadImage } from "../../../../components/imageUploadCompont";
import { DEFAULT_IMAGE_URL } from "../../../../constants/constans";
import { getImageUrl } from "../../../../dummyData/FoodAttributes";
import { OptionType } from "../../../../dummyData/dummyData";
import {
  CreateCustomizeMenuItem,
  ExtraItem,
  MenuItemSection,
} from "../../../../redux/customizeMenuSlice";
import {
  CustomTypeResponse,
  useLazyGetDimensionsQuery,
  useLazyGetMenuTypesQuery,
} from "../../../../redux/services/CustomTypeService";
import {
  useCreateCustomMenuItemMutation,
  useUploadCustomizeMenuLogoFileExtntionHttpsMutation,
} from "../../../../redux/services/customizeMenuService";
import {
  useGetAllergenInformationQuery,
  useGetFoodAttributesListQuery,
  useLazyGetRestaurantFilterTagsQuery,
} from "../../../../redux/services/menuItemService";
import { useLazyGetMenuItemListQuery } from "../../../../redux/services/setMenuService";
import {
  capitalizeFirstLetter,
  customFilterOption,
} from "../../../../utility/Utility";

function AddCustomizedMenu() {
  const navigate = useNavigate();

  const RestID = useSelector(
    (state: any) => state.restaurant.selectedRestaurantDetails.id
  );

  //Retrieve Restaurant Data from Redux Store
  const reastaurantData = useSelector(
    (state: any) => state?.restaurant?.selectedRestaurantDetails
  );

  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<any>({});
  const {
    control: sectionControl,
    handleSubmit: handleSectionSubmit,
    reset: resetSection,
    watch: watchSection,
  } = useForm<any>({});

  const [sections, setSections] = useState<any[]>([]);
  const [extraItems, setExtraItems] = useState<ExtraItem[]>([]);
  const [selectedSectionType, setSelectedSectionType] =
    useState<SingleValue<OptionType>>(null);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [selectedExtraItemType, setSelectedExtraItemType] =
    useState<SingleValue<OptionType>>(null);
  const [selectedMenuItemOption, setSelectedMenuItemOption] =
    useState<SingleValue<any>>(null);
  const [maxCountErrorMessage, setMaxCountErrorMessage] = useState<
    string | null
  >(null);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [canPortion, setCanPortion] = useState(false);
  // const [portionSize, setPortionSize] = useState("");
  // const [portionPrice, setPortionPrice] = useState("");
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [portions, setPortions] = useState<
    { displayName: string; additionalCost: number }[]
  >([]);
  // const [portionErrorMessage, setPortionErrorMessage] = useState<string | null>(
  //   null
  // );
  const [duplicateItemError, setDuplicateItemError] = useState<string | null>(
    null
  );
  const [isSaving, setIsSaving] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  // const [isPortionPriceDisable, setIsPortionPriceDisable] =
  //   useState<boolean>(false);
  const [uploadedImgDetails, setUploadedImgDetails] = useState<{
    imgSrc: string;
    formData: any;
    fileExtention: string;
  }>({
    imgSrc: "",
    formData: "",
    fileExtention: "",
  });
  const [isPreOrder, setIsPreOrder] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [selectedDimensionValues, setSelectedDimensionValues] = useState<{
    [dimensionId: string]: any;
  }>({});

  const [createCustomMenuItem] = useCreateCustomMenuItemMutation();

  const [uploadLogoFileExtetion] =
    useUploadCustomizeMenuLogoFileExtntionHttpsMutation();

  const [triggerGetMenuItemList, { isLoading, data: menuItemsData }] =
    useLazyGetMenuItemListQuery();

  const [triggerGetMenuTypes, { data: menuTypesData }] =
    useLazyGetMenuTypesQuery();

  // const [triggerGetPortionSizes, { data: portionSizesData = [] }] =
  //   useLazyGetPortionSizesQuery();

  // Fetch dimensions for selected custom menu type
  const [triggerGetDimensions, { data: dimensionsData = [] }] =
    useLazyGetDimensionsQuery();

  const { data: allergenData } = useGetAllergenInformationQuery();

  const { data: foodAttributesData } = useGetFoodAttributesListQuery();

  const [
    triggerGetFilterTags,
    { data: filterTagsData, isLoading: isFilterTagsLoading },
  ] = useLazyGetRestaurantFilterTagsQuery();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const menuTypes: CustomTypeResponse[] = menuTypesData || [];

  useEffect(() => {
    if (RestID) {
      triggerGetFilterTags(RestID);
    }
  }, [RestID, triggerGetFilterTags]);

  const filterTagsOptions = React.useMemo(() => {
    if (isFilterTagsLoading || !filterTagsData) return [];

    const options: { value: string; label: string }[] = [];

    // Iterate over each category in filterTags
    Object.entries(filterTagsData.filterTags).forEach(
      ([category, categoryData]) => {
        if (categoryData.tags && Array.isArray(categoryData.tags)) {
          categoryData.tags.forEach((tag) => {
            if (tag.show) {
              options.push({ value: tag.tag, label: `${tag.tag}` });
            }
          });
        }
      }
    );

    return options;
  }, [filterTagsData, isFilterTagsLoading]);

  // useEffect(() => {
  //   if (RestID) {
  //     triggerGetPortionSizes({ restaurantId: RestID });
  //   }
  // }, [RestID, triggerGetPortionSizes]);

  // Fetch dimensions when custom menu type is selected
  useEffect(() => {
    if (RestID && selectedSectionType?.value) {
      // Find the menu type object to get its ID
      const selectedType = menuTypes.find(
        (type) => type.name === selectedSectionType.value
      );

      if (selectedType?.id) {
        triggerGetDimensions({
          restaurantId: RestID,
          customMenuItemTypeId: selectedType.id,
        });
      }
    } else {
      // Clear dimensions when no type is selected
      setSelectedDimensionValues({});
    }
  }, [RestID, selectedSectionType?.value, triggerGetDimensions, menuTypes]);

  // const portionSizesOptions = portionSizesData.map((size) => ({
  //   value: size.portionSize,
  //   label: size.portionSize,
  // }));

  useEffect(() => {
    if (RestID) {
      triggerGetMenuItemList({ restaurantId: RestID });
      triggerGetMenuTypes({ restaurantId: RestID });
    }
  }, [RestID, triggerGetMenuItemList, triggerGetMenuTypes]);

  const allergenOptions =
    allergenData?.allergenInformation.map((allergen) => ({
      value: allergen.displayName,
      label: (
        <div style={{ display: "flex", justifyContent: "left", gap: "2%" }}>
          <img
            src={getImageUrl(allergen.displayName)}
            alt={allergen.displayName}
            width="20px"
            height="20px"
          />
          {allergen.displayName}
        </div>
      ),
    })) || [];

  const foodAttributesOptions =
    foodAttributesData?.FoodAttributesList.map((attr) => ({
      value: attr.displayName,
      label: (
        <div style={{ display: "flex", justifyContent: "left", gap: "2%" }}>
          <img
            src={getImageUrl(attr.displayName)}
            alt={attr.displayName}
            width="20px"
            height="20px"
          />
          {attr.displayName}
        </div>
      ),
    })) || [];

  const menuItemsOptions =
    menuItemsData
      ?.filter((item: any) => item.isCustomMenuItem)
      .map((item: any) => ({
        value: item.itemId,
        displayName: item.displayName,
        label: (
          <div style={{ display: "flex", justifyContent: "left", gap: "5%" }}>
            <img
              src={item.imageUrl || DEFAULT_IMAGE_URL}
              alt=""
              width="50px"
              height="50px"
            />
            {item.displayName}
          </div>
        ),
        price: item.price,
      })) || [];

  const imageUploadCallback = (e: any) => {
    setUploadedImgDetails({
      ...uploadedImgDetails,
      imgSrc: e.imgSrc,
      formData: e.formData,
      fileExtention: e.fileExtention,
    });
  };

  useEffect(() => {
    if (menuTypes.length > 0) {
      setSelectedSectionType(null);
      setSelectedExtraItemType(null);
    }
  }, [menuTypes]);

  // Fetch dimensions when custom menu type is selected
  useEffect(() => {
    if (RestID && selectedSectionType?.value) {
      // Find the menu type object to get its ID
      const selectedType = menuTypes.find(
        (type) => type.name === selectedSectionType.value
      );

      if (selectedType?.id) {
        triggerGetDimensions({
          restaurantId: RestID,
          customMenuItemTypeId: selectedType.id,
        });
      }
    } else {
      // Clear dimensions when no type is selected
      setSelectedDimensionValues({});
    }
  }, [RestID, selectedSectionType?.value, triggerGetDimensions, menuTypes]);

  const menuOptions = menuTypes.map((type) => ({
    value: type.name,
    label: type.name,
  }));

  // Keep track of selected section types and extra item types
  const selectedSectionTypes = sections.map((section) => section.type?.value);
  // const selectedExtraItemTypes = extraItems.map((item) => item.customItemType);

  // Filter menuOptions to exclude selected section types
  const filteredMenuOptions = menuOptions.filter(
    (option) => !selectedSectionTypes.includes(option.value)
  );

  // const filteredExtraMenuOptions = menuOptions.filter(
  //   (option) => !selectedExtraItemTypes.includes(option.value)
  // );

  const menuCategories: any = reastaurantData?.categoryTags.map(
    (value: any) => {
      return {
        value: capitalizeFirstLetter(value),
        label: capitalizeFirstLetter(value),
      };
    }
  ) || [{ value: "", label: "" }];

  // Watch fields in section and extra item forms
  const sectionName = watchSection("sectionName");
  const sectionCount = watchSection("count");
  // const extraItemName = watchSection("displayName");
  // const extraItemPrice = watchSection("price");

  const isSectionAddButtonDisabled =
    !sectionName || !sectionCount || !selectedSectionType;
  // const isExtraItemAddButtonDisabled =
  //   !extraItemName || !extraItemPrice || !selectedExtraItemType;
  // const isPortionButtonDisabled = !portionSize || !portionPrice;

  // Form Submission Handler
  const onSubmit = async (data: CreateCustomizeMenuItem) => {
    if (sections.length === 0) {
      setErrorMessage("Cannot save without adding any sections");
      return;
    }
    setIsSaving(true);

    // Format sections for payload
    const formattedSections: MenuItemSection[] = sections.map((section) => ({
      displayName: section.sectionName,
      maxAllowedCount: parseInt(section.count),
      isRequired: section.isRequired,
      customItemType: section.type ? section.type.value : "",
      customMenuItemTypeId: section.customMenuItemTypeId || "",
    }));

    // Format extra items for payload
    const formattedExtraItems: ExtraItem[] = extraItems.map((item) => ({
      displayName: item.displayName,
      price: +item.price,
      type: item.type,
      customItemType: item.customItemType,
      menuItemId: item.menuItemId,
      customMenuItemTypeId: item.customMenuItemTypeId || "",
    }));

    try {
      // Upload Image and get URL
      const imageUrl = await uploadImage(uploadLogoFileExtetion, {
        fileExtention: uploadedImgDetails.fileExtention,
        formData: uploadedImgDetails.formData,
      });
      const structuredTags: { [key: string]: string[] } = {};

      // Loop through selected tags and group by category
      if (filterTagsData?.filterTags && data.filterTags) {
        Object.entries(filterTagsData.filterTags).forEach(
          ([categoryKey, categoryData]) => {
            const selectedTags = (data.filterTags ?? [])
              .map((tag: any) => tag.value)
              .filter((tagValue: string) =>
                (categoryData.tags as any[]).some(
                  (tagObj) => tagObj.tag === tagValue
                )
              );

            if (selectedTags.length > 0) {
              structuredTags[categoryKey.toLowerCase()] = selectedTags.map(
                (tag: string) => tag.toLowerCase()
              );
            }
          }
        );
      }
      // Prepare payload for API
      const payload: CreateCustomizeMenuItem = {
        restaurantId: RestID,
        displayName: data.displayName,
        tinyId: +(data.tinyId ?? 0) || 0,
        abbreviation: data.abbreviation,
        imageReference: imageUrl,
        category: data.category.value,
        sections: formattedSections,
        price: +data.price!,
        // totalItems: +data.totalItems,
        totalItems: 10,
        extraItems: formattedExtraItems,
        allergenInformation: data?.allergenInformation?.map(
          (item: any) => item.value
        ),
        foodAttributes: data?.foodAttributes?.map((item: any) => item.value),
        supportPortionSizes: canPortion,
        portions: portions.map((portion) => ({
          displayName: portion.displayName,
          additionalCost: portion.additionalCost,
        })),
        productId: data.productId,
        filterTags: data?.filterTags?.map((item: any) => item.value),
        tags: structuredTags,
        supportsPreOrdering: isPreOrder,
      };
      const response: any = await createCustomMenuItem(payload).unwrap();
      if (
        response?.error?.status === 409 &&
        response?.error?.data === "ProductId Already exists"
      ) {
        toast.error("ProductId Already exists");
        setIsSaving(false);
      } else {
        toast.success("Customize menu created");
        navigate("/productCatalogue/products");
      }
    } catch (error: any) {
      if (error.status === 409) {
        toast.error("Customize menu name already exists");
      } else {
        toast.error("Something went wrong");
      }
    } finally {
      setIsSaving(false);
    }
  };

  // Add Section Handler
  const addSection = (sectionData: any) => {
    const selectedType = menuTypes.find(
      (type) => type.name === selectedSectionType?.value
    );

    // Skip availableCount validation for custom menu types with only one dimension
    const shouldSkipValidation = dimensionsData && dimensionsData.length === 0;

    if (
      selectedType &&
      !shouldSkipValidation &&
      sectionData.count > (selectedType.availableCount ?? 0)
    ) {
      setMaxCountErrorMessage(
        "Your max allowed count is greater than the availableCount"
      );
      return;
    }
    setSections([
      ...sections,
      {
        ...sectionData,
        type: selectedSectionType,
        customMenuItemTypeId: selectedType?.id || "",
      },
    ]);
    resetSectionForm();
  };

  // Add Extra Item Handler
  // const addExtraItem = (itemData: any) => {
  //   const selectedType = menuTypes.find(
  //     (type) => type.name === selectedExtraItemType?.value
  //   );

  //   const newItem: ExtraItem = {
  //     displayName: itemData.displayName,
  //     price: itemData.price,
  //     type: selectedMenuItemOption?.value === "item" ? "item" : "group",
  //     customItemType: selectedExtraItemType?.value,
  //     menuItemId: itemData.itemId,
  //     customMenuItemTypeId: selectedType?.id || "",
  //   };
  //   setExtraItems([...extraItems, newItem]);
  //   resetSectionForm();
  // };

  // Portion Checkbox Change Handler
  // const handleCheckboxChangeForPortion = (
  //   event: React.ChangeEvent<HTMLInputElement>
  // ) => {
  //   setCanPortion(event.target.checked);
  // };

  // Add Portion Handler
  // const addPortion = () => {
  //   const portionExists = portions.some(
  //     (portion) => portion.displayName === portionSize
  //   );

  //   if (portionExists) {
  //     setPortionErrorMessage("Portion size is already added.");
  //   } else {
  //     setPortions([
  //       ...portions,
  //       { displayName: portionSize, additionalCost: Number(portionPrice) },
  //     ]);
  //     setPortionSize("");
  //     setPortionPrice("");
  //     setValue("portionSize", "");
  //     setValue("portionPrice", "");
  //     setPortionErrorMessage(null);
  //   }
  // };

  // Delete Portion Handler
  // const deletePortion = (index: number) => {
  //   const updatedPortions = portions.filter((_, i) => i !== index);
  //   setPortions(updatedPortions);
  //   setPortionErrorMessage(null);
  // };

  const resetSectionForm = () => {
    resetSection({
      sectionName: "",
      count: "",
      isRequired: false,
      itemName: "",
      price: "",
    });
    setSelectedSectionType(null);
    setSelectedExtraItemType(null);
    setErrorMessage(null);
  };

  const deleteSection = (index: number) => {
    const newSections = [...sections];
    newSections.splice(index, 1);
    setSections(newSections);
  };

  const deleteExtraItem = (index: number) => {
    const newExtraItems = [...extraItems];
    newExtraItems.splice(index, 1);
    setExtraItems(newExtraItems);
  };

  const addMenuItem = () => {
    if (selectedMenuItemOption) {
      const isDuplicate = extraItems.some(
        (item) => item.menuItemId === selectedMenuItemOption.value
      );

      if (isDuplicate) {
        setDuplicateItemError("The item already exists.");
        return;
      }

      if (selectedMenuItemOption) {
        const newItem: ExtraItem = {
          menuItemId: selectedMenuItemOption.value,
          displayName: selectedMenuItemOption.displayName,
          price: selectedMenuItemOption.price,
          type: "item",
          customMenuItemTypeId: "", // Single menu items don't have custom menu type ID
        };
        setExtraItems([...extraItems, newItem]);
        setSelectedMenuItemOption(null);
        setDuplicateItemError(null);
      }
    }
  };
  // const handleSelectPortion = (option: any) => {
  //   setPortionSize(option.value);

  //   if (option.value === portionSizesData[0].portionSize) {
  //     setValue("portionPrice", 0);
  //     setIsPortionPriceDisable(true);
  //   } else {
  //     setIsPortionPriceDisable(false);
  //   }
  // };

  // const handleDimensionValueChange = (dimensionId: string, selectedOption: any) => {
  //   setSelectedDimensionValues(prev => ({
  //     ...prev,
  //     [dimensionId]: selectedOption
  //   }));
  // };
  return (
    <div>
      <BreadCrumbs hasSubMenus={true} />
      <br />
      <Card>
        <CardHeader style={{ backgroundColor: "#fff" }}>
          <h4>Create Customize Menu</h4>
        </CardHeader>
        <CardBody>
          {isLoading ? (
            <div className="bg-white">
              <LoadingMessage />
            </div>
          ) : (
            <form
              className="auth-login-form mt-2"
              onSubmit={handleSubmit(onSubmit)}
            >
              <IMGUploadComponent
                imageUrl={uploadedImgDetails.imgSrc}
                onUpload={imageUploadCallback}
              />
              <hr />
              <ControlledRowTextField
                label={"Customize Menu Name"}
                inputName={"displayName"}
                inputType={"text"}
                placeholder={"Enter Customize Menu Name"}
                isRequired={true}
                control={control}
                rules={{ required: "Customize Menu Name is required" }}
              />
              {errors.displayName && (
                <span className="text-danger">
                  {errors.displayName.message as string}
                </span>
              )}
              <hr />
              <ControlledRowTextField
                label={"Abbreviation"}
                inputName={"abbreviation"}
                inputType={"text"}
                placeholder={"Enter Abbreviation"}
                control={control}
              />
              <hr />

              <ControlledSelect
                label={"Category"}
                inputName={"category"}
                control={control}
                isMulti={false}
                optionsList={menuCategories}
                rules={{ required: "Category is required" }}
              />
              {errors.category && (
                <p className="text-danger">
                  {errors.category.message as string}
                </p>
              )}
              <hr />
              <div>
                <Row>
                  <Col md={4}>
                    <label>Price (Rs.)</label>
                  </Col>
                  <Col md={8}>
                    <Controller
                      name="price"
                      control={control}
                      rules={{
                        required: "Price is required",
                        validate: (value) =>
                          value > 0 || "Price must be greater than 0",
                      }}
                      render={({ field }) => (
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Enter price"
                          {...field}
                        />
                      )}
                    />
                  </Col>
                </Row>
                {errors.price && (
                  <span className="text-danger">
                    {errors.price.message as string}
                  </span>
                )}
              </div>
              {/* <hr /> */}
              {/*
              <div>
                <Row>
                  <Col md={4}>
                    <label>Total Items</label>
                  </Col>
                  <Col md={8}>
                    <Controller
                      name="totalItems"
                      control={control}
                      rules={{ required: "Total Items is required" }}
                      render={({ field }) => (
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Enter total items"
                          {...field}
                        />
                      )}
                    />
                  </Col>
                </Row>
                {errors.totalItems && (
                  <span className="text-danger">
                    {errors.totalItems.message as string}
                  </span>
                )}
              </div>
              */}
              <hr />

              <ControlledRowTextField
                label={"Product ID"}
                inputName={"productId"}
                inputType={"text"}
                placeholder={"Enter Product ID"}
                isRequired={true}
                control={control}
              />
              <hr />
              <ControlledRowTextField
                label={"Tiny ID"}
                inputName={"tinyId"}
                inputType={"number"}
                placeholder={"Enter Tiny ID"}
                control={control}
                rules={{
                  min: {
                    value: 0,
                    message: "Tiny ID must be 0 or greater",
                  },
                  pattern: {
                    value: /^[0-9]+$/,
                    message: "Tiny ID must be a number",
                  },
                }}
              />

              <hr />
              <ControlledSelect
                label={"Allergic Infromation"}
                inputName={"allergenInformation"}
                control={control}
                isMulti={true}
                optionsList={allergenOptions}
              />

              <hr />
              <ControlledSelect
                label={"Food Attributes"}
                inputName={"foodAttributes"}
                control={control}
                isMulti={true}
                optionsList={foodAttributesOptions}
              />
              <hr />
              <ControlledSelect
                label={"Filter Tags"}
                inputName={"filterTags"}
                control={control}
                isMulti={true}
                optionsList={filterTagsOptions}
              />
              <hr />
              <Row>
                <Col lg="4">
                  <Label
                    className="form-check-label"
                    htmlFor="supportsPreOrdering"
                  >
                    Supports Pre-Ordering
                  </Label>
                </Col>
                <Col lg="8">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="supportsPreOrdering"
                    checked={isPreOrder}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      setIsPreOrder(event.target.checked);
                      setValue("supportsPreOrdering", event.target.checked);
                    }}
                  />
                </Col>
              </Row>
              <hr />
              {/*
              <Row className="mb-3">
                <Col lg={4}>
                  <Label>Portion Available</Label>
                </Col>
                <Col lg={8}>
                  <input
                    type="checkbox"
                    checked={canPortion}
                    className="form-check-input"
                    onChange={handleCheckboxChangeForPortion}
                  />
                  <hr />
                  {canPortion && (
                    <div className="portion-section">
                      <div className="portion-inputs">
                        <Row>
                          <Col md={5} className="mt-1">
                            <ControlledRowSelectPortion
                              inputName="portionSize"
                              control={control}
                              optionsList={portionSizesOptions}
                              isClear
                              placeholder="Select portion size"
                              onChange={(option: any) =>
                                // setPortionSize(option ? option.value : "")
                                handleSelectPortion(option)
                              }
                            />
                            <br />
                          </Col>

                          <Col md={5}>
                            <ControlledRowTextFieldForPortion
                              inputName={"portionPrice"}
                              inputType={"number"}
                              placeholder={"Enter portion price"}
                              isClear
                              control={control}
                              isDisabled={isPortionPriceDisable}
                              onChange={(e) => {
                                const value = Number(e.target.value);
                                if (value >= 0) {
                                  setPortionPrice(e.target.value);
                                } else {
                                  setPortionPrice("");
                                  setPortionErrorMessage(
                                    "Portion price cannot be negative."
                                  );
                                }
                              }}
                            />
                          </Col>

                          <Col md={2}>
                            <ButtonComponent
                              type="button"
                              titel="+Add"
                              // isDisabled={isPortionButtonDisabled}
                              isDisabled={
                                portionSizesData?.[0]?.portionSize ===
                                portionSize
                                  ? false
                                  : isPortionButtonDisabled
                              }
                              onClick={addPortion}
                            />
                          </Col>
                        </Row>
                      </div>
                      {portionErrorMessage && (
                        <div className="text-danger mt-2">
                          {portionErrorMessage}
                        </div>
                      )}
                      <Table>
                        <thead>
                          <tr>
                            <th>Size</th>
                            <th>Price</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {portions.map((portion, index) => (
                            <tr key={index}>
                              <td>{portion.displayName}</td>
                              <td>{portion.additionalCost}</td>
                              <td>
                                <Button
                                  variant="light"
                                  onClick={() => deletePortion(index)}
                                >
                                  <FontAwesomeIcon
                                    icon={faTrash}
                                    title="Delete"
                                    color="#F24E1E"
                                  />
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  )}
                </Col>
              </Row>
              */}
            </form>
          )}
        </CardBody>
      </Card>
      {/* sections */}
      <Card className="mt-3">
        <CardBody className="mt-3">
          <h4>Sections</h4>
          <Form>
            <Row>
              <Col md={3}>
                <Controller
                  name="sectionName"
                  control={sectionControl}
                  defaultValue=""
                  render={({ field }) => (
                    <Form.Group>
                      <Form.Label>Section Name</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter section name"
                        {...field}
                      />
                    </Form.Group>
                  )}
                />
              </Col>
              <Col md={2}>
                <Controller
                  name="count"
                  control={sectionControl}
                  defaultValue=""
                  render={({ field }) => (
                    <Form.Group>
                      <Form.Label>Max Count</Form.Label>
                      <Form.Control
                        type="number"
                        placeholder="Enter count"
                        {...field}
                        onChange={(e) => {
                          setMaxCountErrorMessage(null);
                          field.onChange(e);
                        }}
                      />
                      {maxCountErrorMessage && (
                        <span className="text-danger">
                          {maxCountErrorMessage}
                        </span>
                      )}
                    </Form.Group>
                  )}
                />
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Custom Menu Type</Form.Label>
                  <Controller
                    name="type"
                    control={sectionControl}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={filteredMenuOptions}
                        value={selectedSectionType}
                        onChange={setSelectedSectionType}
                        placeholder="Select type"
                        isClearable
                        filterOption={customFilterOption}
                      />
                    )}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Controller
                  name="isRequired"
                  control={sectionControl}
                  defaultValue={false}
                  render={({ field }) => (
                    <Form.Group>
                      <Form.Label>Required</Form.Label>
                      <Form.Check
                        type="checkbox"
                        checked={field.value}
                        onChange={(e) => field.onChange(e.target.checked)}
                      />
                    </Form.Group>
                  )}
                />
              </Col>
              <Col md={2} className="d-flex align-items-end">
                <ButtonComponent
                  titel="+Add"
                  type="button"
                  isDisabled={isSectionAddButtonDisabled}
                  onClick={handleSectionSubmit(addSection)}
                />
              </Col>
            </Row>
          </Form>
          <hr />
          <div className="selected-items-container">
            <h5>Selected Items</h5>
            <Table bordered className="mt-3" responsive>
              <thead>
                <tr>
                  <th>Section Name</th>
                  <th>Count</th>
                  <th>Custom Menu Type</th>
                  <th>Required</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {sections.map((section, index) => (
                  <tr key={index}>
                    <td>{section.sectionName}</td>
                    <td>{section.count}</td>
                    <td>{section.type ? section.type.label : ""}</td>
                    <td>{section.isRequired ? "Yes" : "No"}</td>
                    <td>
                      <Button
                        variant="light"
                        onClick={() => deleteSection(index)}
                      >
                        <FontAwesomeIcon
                          icon={faTrash}
                          title="Delete"
                          color="#F24E1E"
                        />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            {errorMessage && (
              <div className="text-danger mt-2">{errorMessage}</div>
            )}
          </div>
        </CardBody>
      </Card>
      {/* Extra Items */}
      <Card className="mt-3">
        <CardBody className="mt-3">
          <h4>Extra Items</h4>
          {/* <h5>Add Group Items</h5>
          <Form onSubmit={handleSectionSubmit(addExtraItem)}>
            <Row className="d-flex">
              <Col md={4}>
                <Controller
                  name="displayName"
                  control={sectionControl}
                  defaultValue=""
                  render={({ field }) => (
                    <Form.Group>
                      <Form.Label>Item Name</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter item name"
                        {...field}
                      />
                    </Form.Group>
                  )}
                />
              </Col>
              <Col md={3}>
                <Controller
                  name="price"
                  control={sectionControl}
                  defaultValue=""
                  render={({ field }) => (
                    <Form.Group>
                      <Form.Label>Price</Form.Label>
                      <Form.Control
                        type="number"
                        placeholder="Enter price"
                        {...field}
                      />
                    </Form.Group>
                  )}
                />
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Custom Menu Type</Form.Label>
                  <Controller
                    name="type"
                    control={sectionControl}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={filteredExtraMenuOptions}
                        value={selectedExtraItemType}
                        onChange={setSelectedExtraItemType}
                        placeholder="Select type"
                        isClearable
                        filterOption={customFilterOption}
                      />
                    )}
                  />
                </Form.Group>
              </Col>
              <Col md={2} className="d-flex align-items-end">
                <ButtonComponent
                  titel="+Add"
                  isDisabled={isExtraItemAddButtonDisabled}
                  type="submit"
                />
              </Col>
            </Row>
          </Form> */}

          <br />
          <h5>Add Single Item</h5>
          <Form>
            <Row className="d-flex align-items-center">
              <Col md={10}>
                <Select
                  value={selectedMenuItemOption}
                  onChange={setSelectedMenuItemOption}
                  options={menuItemsOptions}
                  placeholder={isLoading ? "Loading..." : "Search menu item"}
                  isSearchable
                  loadingMessage={() => "Loading menu items..."}
                  noOptionsMessage={() =>
                    isLoading ? "Loading..." : "No items found"
                  }
                  filterOption={customFilterOption}
                />
              </Col>
              <Col md={2} className="d-flex align-items-end">
                <ButtonComponent
                  titel="+Add"
                  type="button"
                  onClick={addMenuItem}
                  isDisabled={!selectedMenuItemOption}
                />
              </Col>
            </Row>
            {duplicateItemError && (
              <div className="text-danger mt-2">{duplicateItemError}</div>
            )}
          </Form>
          <hr />

          <Table bordered responsive>
            <thead>
              <tr>
                <th>Item Name</th>
                <th>Price</th>
                <th>Custom Menu Type</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {extraItems.map((item, index) => (
                <tr key={index}>
                  <td>{item.displayName}</td>
                  <td>{item.price}</td>
                  <td>{item.type === "item" ? "-" : item.customItemType}</td>
                  <td>
                    <Button
                      variant="light"
                      onClick={() => deleteExtraItem(index)}
                    >
                      <FontAwesomeIcon
                        icon={faTrash}
                        title="Delete"
                        color="#F24E1E"
                      />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </CardBody>
      </Card>

      <div className="d-flex justify-content-end my-2 mx-5">
        {isSaving ? (
          <ButtonComponent
            type="submit"
            icon={<FontAwesomeIcon icon={faSpinner} spin title="Saving..." />}
            titel="Saving..."
            isDisabled={true}
          />
        ) : (
          <ButtonComponent
            titel="Save"
            type="submit"
            onClick={handleSubmit(onSubmit)}
          />
        )}
      </div>
    </div>
  );
}

export default AddCustomizedMenu;
